import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item, mediaCSS } from '../../../theme'

const reportChartStyles: IStyles = {
    wrapper: {
        display: 'flex',
        minHeight: 'calc(100vh - 40px)',
        justifyContent: 'center',
    },
    leftBlock: {
        position: 'relative',
        width: '18%',
        paddingTop: 20,
        borderRight: '2px solid var(--var-module-app-component-app-style-border, #F0F0F0)',
        transition: 'transform 0.5s',
        backgroundColor: colors.white,

        [mediaCSS.tabMini]: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            height: '100%',
            width: 200,
            paddingTop: 40,
            transform: 'translateX(-100%)',
        },
    },
    leftBlockOpened: {
        transform: 'none !important',
    },
    toolbarsTriggers: {
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1,
    },
    panelTrigger: {
        padding: 10,
        background: colors.white,
        borderRadius: 5,
        border: `1px solid ${colors.greyLight}`,
        margin: '0 5px',
    },
    leftBlockTitle: {
        [mediaCSS.tabMini]: {
            paddingLeft: 20,
        },
    },
    leftBlockList: {
        marginTop: 40,
    },
    listItem: {
        display: 'flex',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'no-wrap',
        padding: '14px 5px',
        borderBottom: '2px solid var(--var-module-app-component-app-style-border, #F0F0F0)',
        cursor: 'pointer',

        span: {
            marginLeft: 10,
        },
    },
    selectedItem: {
        backgroundColor: colors.blueWhite,
    },
    centerBlock: {
        width: '64%',
        minWidth: 430,

        [mediaCSS.tabMini]: {
            width: '100%',
            paddingTop: 30,
        },
    },
    tabs: {
        padding: '0 20px',
        marginBottom: 40,
    },
    rightBlock: {
        width: '18%',
        padding: '20px',
        borderLeft: '2px solid var(--var-module-app-component-app-style-border, #F0F0F0)',
        transition: 'transform 0.5s',
        backgroundColor: colors.white,

        [mediaCSS.tabMini]: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            height: '100%',
            width: 200,
            paddingTop: 40,
            transform: 'translateX(100%)',
        },
    },
    rightBlockOpened: {
        transform: 'none !important',
    },
    chartWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        margin: '0 auto',
        width: '40%',

        [mediaCSS.tab]: {
            width: '100%',
        },
    },
    paramsList: {
        marginTop: 40,
    },
    param: {
        marginTop: 10,
        cursor: 'pointer',
    },
    selectedParam: {
        fontWeight: 600,
    },
    noData: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        fontSize: 18,
        fontWeight: 600,
    },
}

addStyles(reportChartStyles)
export default reportChartStyles
